import  ActivityTypes from '../../enums/activityTypes';

export const ActivityUtils = {
  filterSearchRequest: (keywords, vocabulariesPerPage, context) => {
    return {
      keyword: keywords,
      pageNumber: 1,
      pageSize: vocabulariesPerPage ,
      courseIds: context.courseFilters.filter(f => f.isChecked).map(f => f.id),
      levels: context.levelFilters.filter(f => f.isChecked).map(f => f.id),
      teacherAssignmentIds: context.personalAssignmentFilters.filter(f => f.isChecked).map(f => f.id),
      publicAssignmentIds: context.publicAssignmentFilters.filter(f => f.isChecked).map(f => f.id),
      topics: context.topicFilters.filter(f => f.isChecked).map(f => f.id)
    };
  },
  getActivityName: (activityType) => {
    switch (parseInt(activityType)) {
    case ActivityTypes.Assignment:
      return 'Assignment';
    case ActivityTypes.Assessment:
      return 'Assessment';
    case ActivityTypes.FlashCard:
      return 'Flashcard';
    default:
      return '';
    }
  }
};